/**
 * Created by wumian on 17/11/21.
 */
import Vue from 'vue';


function num9(value) {
  if (value < 10) {
    return '0' + value
  } else {
    return value
  }
}
// 注册
Vue.filter('num9', num9);


function timeDian(value) {
  if (value) {
    var newDate = new Date(value);
    var year = newDate.getFullYear();
    var month = newDate.getMonth() + 1;
    var day = newDate.getDate();
    return year + '.' + month + '.' + day;
  } else {
    return ''
  }

}
Vue.filter('timeDian', timeDian);


function nullTo0(value) {
  if (value) {
    return value
  } else {
    return 0
  }
}
Vue.filter('nullTo0', nullTo0);


function dateLineToCH(value) {
  if(value){
    var str = value;
    str = str.replace('-', '年');
    str = str.replace('-', '月');
    str = str + '日';
    return str
  }
}
Vue.filter('dateLineToCH', dateLineToCH);




// WEBPACK FOOTER //
// ./src/assets/js/filter.js